import { useEffect, useState } from "react"
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { AddWorkoutTypeAsync, GetWorkoutTypesAsync, RemoveWorkoutTypeAsync, selectEditFlag, selectWorkoutTypesList, setEditFlag } from "../features/add_workout/workoutSlice";
import { Button, FormControl, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from "@mui/material";
import { tableDesign } from "../app/consts";
import { useConfirm } from "./AlertDialogModal";

const ManageWorkoutTypes = () => {
  const dispatch = useAppDispatch();
  const [Name, setName] = useState("")
  const editFlag = useAppSelector(selectEditFlag);
  const WorkoutTypes = useAppSelector(selectWorkoutTypesList);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const confirm = useConfirm()

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    dispatch(GetWorkoutTypesAsync())
    // eslint-disable-next-line
  }, [editFlag])

  const handleSubmit = () => {
    let noErrors = document.querySelector<HTMLInputElement>('form[id="addWorkoutType"]')?.checkValidity();
    if (WorkoutTypes.find((value) => value.name === Name))
      toast.error("אימון בשם זה כבר קיים");
    else if (noErrors) {
      dispatch(AddWorkoutTypeAsync({ 'name': Name }))
        .then(() => {
          dispatch(setEditFlag());
          toast.success("המאמן התווסף בהצלחה!"); document.forms[0].reset();
        })
        .catch((reason) => toast.error(reason))
    }
    else
      toast.error("קיימת טעות בטופס, אנא וודא את הפרטים שמולאו");
  }

  const handleRemove = async(type)=>{
    
    const handleConfirmation = async (title:string,content:string) => {
      const isConfirmed = await confirm({
        title: title,
        content: content,
        });
          return isConfirmed
      }
    
    const title = "מחיקת סוג אימון"
    const content = `אנא אשר מחיקת אימון מסוג ${type.name}`

    const isConfirmed = await handleConfirmation(title,content)
    if(isConfirmed){
      dispatch(RemoveWorkoutTypeAsync(+type.id)).unwrap()
      .then(()=>{
        toast.success("הפעולה בוצעה בהצלחה");
        dispatch(setEditFlag());
      })
      .catch(()=>{
        toast.error("הפעולה בוטלה");
        return
      })
    }
  }

  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginTop: '2%' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <form id='addWorkoutType' method='post' onSubmit={(e) => e.preventDefault()}>
            <FormControl>
              <TextField variant="filled" label='סוג האימון' type='text' onChange={(e) => setName(e.target.value)} required style={{ textAlign: 'center', width: '300px', }} />
              <br />
              <Button type='submit' onClick={(e) => handleSubmit()} variant="contained" size='large' color='success'
              >הוסף סוג אימון</Button>
            </FormControl>
          </form>
          <hr />
        </div>

        <div>
          {WorkoutTypes.length === 0 ?
            <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', }} />
            :
            <Paper sx={tableDesign}>
              <TableContainer sx={{maxHeight: 600}}>
                <Table stickyHeader aria-label="sticky table" sx={{ "& .MuiTableCell-root": { fontSize: "1em", textAlign: 'center' } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>פעולות</TableCell>
                      <TableCell>שם מלא</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {WorkoutTypes?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((type, index) =>
                      <TableRow key={index}>
                        <TableCell><Button variant="contained" size='small' color='error' onClick={() => handleRemove(type)}>מחק</Button></TableCell>
                        <TableCell>{type.name}</TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={WorkoutTypes.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ justifySelf: 'right', direction: 'ltr' }}
              />
            </Paper>
          }
        </div>
      </div>
    </div >
  )
}

export default ManageWorkoutTypes;